import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { getCookie } from '../../../common/utils/api_utils';
class PageDetail extends Component {
  render() {
    const { redirectUrl, page, version } = this.props;
    const { name, uuid, projectId } = page;
    let token = getCookie('token');
    if (!token) {
      token = '';
    }
    return (
      <Fragment>
        <a
          href={`${redirectUrl}editor/${version}/v/${projectId}/pages/${uuid}?token=${token}`}
          className={`list-group-item list-group-item-action align-items-center`}
          style={{ cursor: 'pointer', float: 'left' }}
        >
          <i className="gjs-caret-icon wb webconnect-file-earmark-text"></i>&nbsp; {name}
        </a>
      </Fragment>
    );
  }
}

PageDetail.propTypes = {
  page: PropTypes.object.isRequired,
};

export default PageDetail;
